module.exports = __webpack_public_path__ + "static/media/dishwasher.0d3c0a53.svg";